// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';

import type { ExtendedSuggestion } from '../../../types';

type Props = {
  availability: ExtendedSuggestion['availability'],
  isEarlyAccess: boolean,
  addedToCart?: boolean,
};

export function AvailabilityText({
  availability,
  isEarlyAccess,
  addedToCart,
}: Props): React.MixedElement {
  const { __ } = useTranslator();

  if (availability === 'available') {
    if (isEarlyAccess)
      return (
        <span>
          {__('Good news! This domain is available in early access.')}
        </span>
      );

    return (
      <span>
        {addedToCart
          ? __('You are about to own the domain!')
          : __('Good news! This domain is available!')}
      </span>
    );
  }

  if (availability === 'lang_required')
    return (
      <span>
        {__('Good news! This domain is available! Let us know the alphabet.')}
      </span>
    );

  if (availability === 'error')
    return (
      <span>{__('Sorry, something unexpected happened. Retry later.')}</span>
    );

  return <span>{__('No! This domain is not available!')}</span>;
}
